document.addEventListener("DOMContentLoaded", function () {
  $(".product-card-new-variant").click(function () {
    console.log($(this));
    let image = $(this).data("image");
    if (image) {
      $(this)
        .parents(".product-card-new")
        .find(".product-card-image")
        .find("img")
        .removeAttr("srcset");
      $(this)
        .parents(".product-card-new")
        .find(".product-card-image")
        .find("img")
        .attr("src", image);
    }
    $(this)
      .parents(".product-card-new")
      .find("a")
      .attr("href", $(this).data("url"));

    let price = $(this).data("price");
    console.log(price);
    let compare_at_price = $(this).data("compare_at_price");
    console.log(compare_at_price);
    if (price) {
      $(this)
        .parents(".product-card-new")
        .find(".product_switch__current-price")
        .text(price);
    }
    if (compare_at_price) {
      $(this)
        .parents(".product-card-new")
        .find(".product_switch__current-original_price")
        .text(compare_at_price);
    } else {
      $(this)
        .parents(".product-card-new")
        .find(".product_switch__current-original_price")
        .text("");
    }
  });
});